/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from "@react-three/drei";
import Helmet from './Helmet.gltf'

function Model(props) {
  const { nodes, materials } = useGLTF(Helmet);
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["node_damagedHelmet_-6514"].geometry}
        material={materials.Material_MR}
        rotation={[Math.PI / 2, 0, 0]}
      />
    </group>
  );
}

useGLTF.preload("./Helmet.gltf");

export default Model